/** @jsx jsx */

import React, {
  Fragment as _,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useCallback,
} from 'react';
import { css, jsx } from '@emotion/core';
import Modal from 'components/UI/Modal';
import checkReturnToInteractionEditing from 'services/checkReturnToInteractionEditing';

const Feedback = props => {
  const {
    result,
    attempt,
    navigationBehaviour,
    showAttemptNumber,
    numberOfAttempts,
    useMediaInFeedback = true,
    onOpened,
    onClose = () => {},
    children,
    id,
    block,
    correct,
    showCorrectAnswer,
  } = props;

  const targetFeedback = children.filter(child => {
    return child.props.type.replace('_Feedback', '').toLowerCase() === result;
  })[0];

  let [img, txt, btn] = targetFeedback.props.children;

  const isImg = img?.props?.child === 1;

  const parsedOnClose = () => {
    if (window.dev()) {
      checkReturnToInteractionEditing(true);
      onClose();
      return;
    }

    onClose();

    if (result === 'attempt') {
      return;
    }

    if (result !== 'correct' && attempt && attempt < numberOfAttempts!) {
      return;
    }

    // this code has been updated since
    // from here the correct / incorrect <a> tags ( buttons ) navigate to their hrefs
  };

  const showAttemptNumberComputed =
    showAttemptNumber &&
    result !== 'correct' &&
    numberOfAttempts! > 1 &&
    attempt! < numberOfAttempts!;

  let nullSpaceCloseAction = () => {};

  if (btn.props.location) {
    if (
      btn.props.location === 'next' ||
      (numberOfAttempts! > 1 && attempt! < numberOfAttempts!)
    ) {
      if (result !== 'correct') {
        nullSpaceCloseAction = onClose;
      }
    }
  } else {
    nullSpaceCloseAction = onClose;
  }

  const feedbackTextCB = useCallback((node: HTMLDivElement | null) => {
    if (node !== null) {
      const chameleonText = node.querySelector(
        '.chameleon-text'
      ) as HTMLDivElement;

      chameleonText?.removeAttribute('tabindex');
    }
  }, []);

  const buttonContainerCB = useCallback(
    (node: HTMLDivElement | null) => {
      if (!node) {
        return;
      }

      const anchorButton = node.querySelector('a');
      if (!anchorButton) {
        return;
      }

      anchorButton.style.margin = '0';

      if (result !== 'correct' && attempt && attempt < numberOfAttempts - 1) {
        anchorButton.style.pointerEvents = 'none';
        return;
      }

      if (result === 'correct' && navigationBehaviour.correct) {
        anchorButton.style.pointerEvents = 'none';
        return;
      }

      if (result !== 'correct' && navigationBehaviour.incorrect) {
        anchorButton.style.pointerEvents = 'none';
        return;
      }
    },
    [
      result,
      attempt,
      numberOfAttempts,
      navigationBehaviour.incorrect,
      navigationBehaviour.correct,
    ]
  );

  return (
    <Modal
      disableNullSpaceClick={window.dev() ? false : true}
      onOpened={onOpened}
      onClose={window.dev() ? onClose : nullSpaceCloseAction}
    >
      <div
        css={css`
          position: relative;
          display: flex;
          flex-direction: column;
          align-items: center;
          width: 100%;
          height: 100%;
          max-width: 768px;
          padding: 50px;
        `}
      >
        {useMediaInFeedback && (
          <div
            css={css`
              width: 75%;
              margin-bottom: 30px;

              img {
                max-height: 30vh !important;
              }

              @media (max-width: 768px) {
                width: 100%;
                margin-bottom: 25px;
              }
            `}
          >
            {img}
          </div>
        )}

        {result === 'attempt' && showAttemptNumberComputed && (
          <div
            style={{
              margin: '0 0 15px 0',
              fontFamily: 'inherit',
              fontWeight: 700,
              color: '#333',
            }}
          >
            <p>
              Attempt {attempt} of {numberOfAttempts}
            </p>
          </div>
        )}
        <div
          ref={feedbackTextCB}
          css={css`
            width: 100%;
            margin-bottom: 30px;
          `}
        >
          {txt}
        </div>
        <div
          ref={buttonContainerCB}
          css={css`
            display: flex;
            justify-self: flex-end;
            justify-content: center;
            width: 100%;
          `}
        >
          <span
            css={css`
              cursor: pointer;

              &:hover {
                opacity: 0.8;
              }

              button {
                pointer-events: none;
              }

              div [class*='NavigationButton'] {
                top: -10px;
                height: calc(100% + 20px);
              }
            `}
            onClick={e => {
              !window.dev() ? parsedOnClose() : null;
            }}
          >
            {btn}
          </span>
        </div>
      </div>
    </Modal>
  );
};

export default Feedback;
